import { passwordStrength } from 'check-password-strength';

window.passwordStrength = passwordStrength;
